import {
  WARD_REQUEST,
  WARD_FAILURE,
  FETCH_WARDS_SUCCESS,
  CREATE_WARD_SUCCESS,
  DELETE_WARD_SUCCESS,
  UPDATE_WARD_SUCCESS,
  GET_WARD_SUCCESS,
} from "../action/types";

const initialState = {
  wards: [],
  total: 0,
  currentWard: null,
  loading: false,
  error: null,
};

const wardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case WARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_WARDS_SUCCESS:
      return {
        ...state,
        loading: false,
        wards: payload?.data ?? (Array.isArray(payload) ? payload : []),
        total: payload?.total ?? (Array.isArray(payload) ? payload.length : 0),
      };

    case GET_WARD_SUCCESS:
      return {
        ...state,
        loading: false,
        currentWard: payload,
        wards: state.wards.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case CREATE_WARD_SUCCESS:
      return {
        ...state,
        loading: false,
        currentWard: payload,
        wards: [payload, ...state.wards],
        total: state.total + 1,
      };

    case UPDATE_WARD_SUCCESS:
      return {
        ...state,
        loading: false,
        currentWard: payload,
        wards: state.wards.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case DELETE_WARD_SUCCESS:
      return {
        ...state,
        loading: false,
        wards: state.wards.filter((item) => item.id !== payload),
        total: state.total - 1,
      };

    case WARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default wardReducer;
